export default "__VITE_ASSET__CQ9_c2Xa__"